/**
 * https://github.com/mui/material-ui/blob/master/examples/joy-ui-nextjs-ts/src/components/ThemeRegistry/theme.ts
 * https://github.dev/mui/material-ui/blob/d37b6cc7e6c7214760b9729c435e028fcb8fe078/packages/mui-joy/src/styles/extendTheme.ts
 */

import getTheme from '@unifyapps/ui/styles/theme';
import { geist, jetBrainsMono } from '@/utils/fonts';

const theme = getTheme({
  fontFamily: {
    body: geist.style.fontFamily,
    display: geist.style.fontFamily,
    text: geist.style.fontFamily,
    code: jetBrainsMono.style.fontFamily,
  },
});

export default theme;
